<app-modals [title]="'MODALS.SUBSCRIPTIONS.TITLE' | translate : plan" [openModal]="openModal" [closeModal]="closeModal" [whenModalClose]="whenModalClose" [submitKey]="submitKey" [invalidFormGroup]="$safeNavigationMigration(entry?.invalid)" [isButtonsDisabled]="isButtonsDisabled" [onDismiss]="onDismiss" [isShaking]="$safeNavigationMigration(errors?.length) > 0">
  <form #entityForm="ngForm" [formGroup]="entry" (ngSubmit)="onSubmit(entry)" novalidate="novalidate">
    @if (errors?.length > 0) {
      <app-form-errors [errors]="errors"></app-form-errors>
    }

    @if (!customer?.default_source) {
      <div class="fadeIn" formGroupName="card">
        <p class="text-muted small">{{ 'MODALS.SUBSCRIPTIONS.CARD' | translate }}</p>
        <div class="row">
          <div class="col-12">
            <app-forms-form-group [value]="entry.get('card').get('name')" fieldName="name" [fieldLabel]="'MODALS.CARDS.NAME' | translate"><input class="form-control" id="name" type="text" autocomplete="name" formControlName="name" appAutoFocus="appAutoFocus" /></app-forms-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-12"><label for="card-element">{{ 'MODALS.CARDS.CARD_NUMBER' | translate }}</label><span class="form-control" id="card-element"></span></div>
        </div>
      </div>
    }

    @if (plan && customer?.default_source) {
      <div class="fadeIn" formGroupName="plan">
        <p class="text-muted small">{{ 'MODALS.SUBSCRIPTIONS.CONFIRMATION' | translate }}</p>
        <div class="card v-card fadeIn">
          <div class="card-header text-center h5 text-uppercase fw-bold v-card--highlight">{{ plan.nickname | titlecase }}</div>
          <div class="card-body text-center v-card--highlight">
            <div class="h1 card-text">{{ 299 | currency : 'USD' : 'symbol' : '1.0-0' }}</div>
            <div class="small card-text">{{ 'MODALS.SUBSCRIPTIONS.PER_MONTH' | translate }}</div>
            <div class="card-text">{{ 'MODALS.SUBSCRIPTIONS.PER_CANDIDATE' | translate }}</div>
          </div>
          <ul class="list-group list-group-flush">
            @for (f of plan.features; track f) {
              <li class="list-group-item d-flex align-items-center" [ngClass]="{ 'disabled v--opacity-50' : f.isDisabled }"><i class="lnr me-2" [ngClass]="f.icon"></i>{{ f.label }}</li>
            }
          </ul>
        </div>
      </div>
    }
  </form>
</app-modals>
